<!--
 * @Author: your name
 * @Date: 2020-12-21 10:22:30
 * @LastEditTime: 2021-01-06 18:09:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zcjb\src\views\home\src\main.vue
-->
<template>
  <main>
    <!--轮播图-->
    <home-swiper></home-swiper>
    <!--投标保函-->
    <home-norml-card v-if="!isHlj"></home-norml-card>
    <!--广告图-->
    <home-advertisement v-if="!isCqsw && !isHlj"></home-advertisement>

    <!--保函&贷款-->
    <home-card v-if="!isCqsw"></home-card>
    <!--他们都在金服-->
    <home-cooperation v-if="!isCqsw"></home-cooperation>
  </main>
</template>

<script>
import HomeSwiper from './components/HomeSwiper'
import HomeNormlCard from './components/HomeNormlCard'
import HomeCard from './components/HomeCard'
import HomeCooperation from './components/HomeCooperation'
import HomeAdvertisement from './components/HomeAdvertisement'
import {
  mapMutations,
  mapState,
  CONFIG_MUTATIONS,
  Config,
} from '@/store/modules/config'

export default {
  components: {
    HomeSwiper,
    HomeNormlCard,
    HomeCard,
    HomeCooperation,
    HomeAdvertisement
  },
  computed: {
    ...mapState({
      state: 'config',
    }),
    isCqsw(){
      return this.$store.state.letter.isCqsw
    },
    isHlj() {
      return this.$store.state.letter.isHlj
    }
  },
  methods: {
    ...mapMutations({
      setConfig: CONFIG_MUTATIONS.SET_CONFIG,
    }),
  },
  beforeMount() {
    if (this.$route.query.origin === Config.ZCM) {
      this.setConfig({
        origin: Config.ZCM,
      })
    }
    if (this.$route.query.origin === Config.SDGS) {
      this.setConfig({
        origin: Config.SDGS,
      })
    }
  },
}
</script>
